import { EcommerceAPI } from "../Client";
import { appendProcessedFile } from "../../../utils/imageUploadProcessor";

const getMetaDataPayload = (payload = {}) => payload?.dto ?? payload;

export const getProductMetaDataAPI = async (payload = {}) => {
  try {
    const productId = payload?.productId ?? payload;
    return await EcommerceAPI.get("/product/meta-data", {
      params: { productId },
    });
  } catch (error) {
    throw error.response || error;
  }
};

export const getAllProductMetaDataAPI = async () => {
  try {
    return await EcommerceAPI.get("/product/all/meta-data");
  } catch (error) {
    throw error.response || error;
  }
};

export const createProductMetaDataAPI = async (payload = {}) => {
  try {
    return await EcommerceAPI.post(
      "/product/meta-data",
      getMetaDataPayload(payload),
      {
        params: { productId: payload?.productId },
      },
    );
  } catch (error) {
    throw error.response || error;
  }
};

export const updateProductMetaDataAPI = async (payload = {}) => {
  try {
    return await EcommerceAPI.put(
      "/product/meta-data",
      getMetaDataPayload(payload),
    );
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteProductMetaDataAPI = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    return await EcommerceAPI.delete("/product/meta-data", {
      params: { id },
    });
  } catch (error) {
    throw error.response || error;
  }
};

export const uploadProductMetaDataIconAPI = async (payload) => {
  try {
    const file = payload?.file ?? payload;
    const formData = new FormData();
    await appendProcessedFile(formData, "file", file);

    return await EcommerceAPI.post("/product/meta-data/icon", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteProductMetaDataIconAPI = async (payload = {}) => {
  try {
    const uploadId = payload?.uploadId ?? payload;
    return await EcommerceAPI.delete("/product/meta-data/icon", {
      params: { uploadId },
    });
  } catch (error) {
    throw error.response || error;
  }
};
